module.exports = __webpack_public_path__ + "img/warranty.1c0c762a.jpg";